<template>
	<div class="home">

		<div class="col-md-offset-1 col-md-10" style="padding-bottom:30px;">
			<div class="panel panel-default drop-shadow text-left">
				<div class="panel-heading panel-grey text-left">
					GET STARTED
				</div>

				<div class="col-md-7">
                    <h3>Follow these steps:</h3>
                    <table> 
                        <tr>
                            <td valign=top style="padding:10px;">
                                <span class="badge" style="font-size:2em; background-color:SlateBlue;">1</span>
                            </td>
                            <td valign=top>
                                <h4>Prepare your data:</h4>
                                Make sure you&apos;re sending the correct version and that you have included any supporting information,
                                such as drafts, notes, sketches, etc, if applicable.
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td valign=top style="padding:10px;">
                                <span class="badge" style="font-size:2em; background-color:SlateBlue;">2</span>
                            </td>
                            <td valign=top>
                                <h4>Send in your data:</h4>
                                Email your file(s) <u>as attachment(s)</u> to <b>{{ prot_em }}</b>.<br>
                                You can attach more than one file.
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td valign=top style="padding:10px;">
                                <span class="badge" style="font-size:2em; background-color:SlateBlue;">3</span>
                            </td>
                            <td valign=top>
                                <h4>Payment<sup>1</sup>:</h4>
                                You will receive a reply which will ask you to confirm the upload, and request payment.<br>
                                Click on the button to process the payment (via PayPal) and that's it!
                                <hr>
                            </td>
                        </tr>
                    </table>
                    A login for the website will be automatically created for you, and details sent to you with the payment confirmation email. 
                    Use this information to view your data and manage your account.
                    <br><br>
                    <small>
                    Notes:<br>
                    1. Corporate users will not have a payment step. Payments will be handled by monthly billing. Get in touch to apply for a corporate account.
                    </small>
                    <br><br>
				</div>
		
				<div class="col-md-4 alert-primary" 
                     style="float:right; margin:5px; border-radius:4px; overflow:hidden;">
                    <h5>About your privacy:</h5>
                    <font size=-1>
                        FiledSafely&apos;s <router-link to="/privacy">Privacy Policy</router-link> is very simple:
                        <br>
                        <ul>
                            <li>Your data is stored safely and securely.</li>
                            <li>Your data is kept completely confidential.</li>
                            <li>Your data is not used by FiledSafely other than to provide this service.</li>
                        </ul>
                    </font>
                </div>						
			</div>
		</div>
		
	</div>
</template>


<script>

export default {
	name: 'get_started',

	props: {
	},
	
	components: {
	},
	
	data() {
		return {
			api_token: '',
            prot_em  : 'dummy@test.com',
		};
	},

	computed: {
	},
	
	created() {
	},

	mounted() {
        this.prot_em  = 'prot';
        this.prot_em += 'ect';
        this.prot_em += '@';
        this.prot_em += 'fil';
        this.prot_em += 'edsafely.';
        this.prot_em += 'com';
	},

	destroyed() {
	},

	methods: {
	},
}

</script>
